module.exports = __webpack_public_path__ + "img/26.7.Chla.588ef0dc.png";